import SpeechText from '@/components/SpeechText';
import Image from '@/components/v2/Image';

const FortunePage1Header = () => {
  return (
    <div className="bg-gradient-to-br from-[#ffdac5] to-[#ffccb0] h-[150px] pl-4 pt-[23px] pb-[18px] flex gap-4 relative">
      <div>
        <div className="w-[150px]">
          <SpeechText className="relative text-[#EAEAEA] w-[150px] text-[11px] h-6 flex justify-center items-center bg-gray-1 rounded-[10px]">
            <span className="translate-y-[1px]">
              ★ 댓글몽 <b>새해 특별 이벤트</b> ★
            </span>
          </SpeechText>
        </div>
        <div className="kcc-ganpan mt-[7px] tracking-[-1.6px]">
          <span className="text-[#4d75e4] text-lg leading-tight tracking-normal">
            2025 을사년
            <br />
          </span>
          <span className="text-[#35373e] text-[32px] leading-9">우리 가게 </span>
          <span className="text-[#f67c38] text-[32px] leading-9">운세는?</span>
        </div>
        <p className="text-[#35373E] text-[9px] mt-1.5">이벤트 기간: 01.20 (월) ~ 02.07 (금)</p>
      </div>
      <div className="absolute top-7 right-4.5">
        <Image src={'/img/fortune/bluedragon_mong.png'} width={107} height={100} alt="몽" />
      </div>
    </div>
  );
};

export default FortunePage1Header;
